"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usStateNameFromCode = void 0;
const exceptions_1 = require("../exceptions");
const map = {
    ct: 'connecticut',
    de: 'delaware',
    dc: 'district of columbia',
    fl: 'florida',
    ga: 'georgia',
    in: 'indiana',
    me: 'maine',
    md: 'maryland',
    ma: 'massachusetts',
    mi: 'michigan',
    nh: 'new hampshire',
    nj: 'new jersey',
    ny: 'new york',
    nc: 'north carolina',
    oh: 'ohio',
    pa: 'pennsylvania',
    ri: 'rhode island',
    sc: 'south corolina',
    vt: 'vermont',
    va: 'virginia',
    wv: 'west virginia',
    az: 'arizona',
    co: 'colorado',
    id: 'idaho',
    mt: 'montana',
    nm: 'new mexico',
    ut: 'utah',
    al: 'alabama',
    ar: 'arkansas',
    il: 'illinois',
    ia: 'iowa',
    ks: 'kansas',
    ky: 'kentucky',
    la: 'louisiana',
    mn: 'minnesota',
    ms: 'mississippi',
    mo: 'missouri',
    ne: 'nebraska',
    nd: 'north dakota',
    ok: 'oklahoma',
    sd: 'south dakota',
    tn: 'tennessee',
    tx: 'texas',
    wi: 'wisconsin',
    as: 'american samoa',
    ak: 'alaska',
    ca: 'california',
    gu: 'guam',
    hi: 'hawaii',
    nv: 'nevada',
    mp: 'northern mariana islands',
    or: 'oregon',
    pr: 'puerto rico',
    vi: 'united states virgin islands',
    wa: 'washington',
    wy: 'wyoming',
};
const usStateNameFromCode = (code) => {
    code = code.toLowerCase();
    if (code in map) {
        return map[code];
    }
    throw new exceptions_1.UnacceptableValueException(`'${code}' is not a valid US state code.`);
};
exports.usStateNameFromCode = usStateNameFromCode;
